import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

// Kullanıcı bazlı çeyreklik prim katsayıları (geçmişiyle birlikte tutulur).
const useUserBonusCoefficients = () => {
  const { user } = useAuth();

  const dynamicHook = useDynamicEntity({
    entityType: 'userBonusCoefficients',
    gqlEntityKey: 'user_bonus_coefficients',
    queryName: 'GET_USER_BONUS_COEFFICIENTS_QUERY',
    createMutation: 'CREATE_USER_BONUS_COEFFICIENT_MUTATION',
    updateMutation: 'UPDATE_USER_BONUS_COEFFICIENT_MUTATION',
    deleteMutation: 'DELETE_USER_BONUS_COEFFICIENT_MUTATION',
    transformData: (row) => ({
      ...row,
      company_name: row.company?.name || `Company ${row.company_id}`,
      user_name: row.user
        ? `${row.user.first_name || ''} ${row.user.last_name || ''}`.trim()
        : `Kullanıcı #${row.user_id}`,
      period_label: `${row.yil}/Q${row.ceyrek}`,
      companyId: row.company_id,
      userId: row.user_id,
    }),
    transformFormData: (formData) => ({
      user_id: parseInt(formData.user_id),
      yil: parseInt(formData.yil) || new Date().getFullYear(),
      ceyrek: parseInt(formData.ceyrek) || 1,
      katsayi: parseFloat(formData.katsayi) || 1,
    }),
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
  });

  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { useUserBonusCoefficients };
